<script>
import ClickOut from '../../../../utils/directives/clickout'
import {emitirSegundaVia, getDocumentoUnificadoGrv} from '../../../../domain/grv/services'
import createDownloadLink from '../../../../utils/create-download-link'
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'

export default {
  name: 'btn-acoes-grv',
  mixins: [AclCheckMixins],
  props: ['grv', 'tipoGrv'],
  directives: {ClickOut},
  components: {},
  data () {
    return {
      open: false,
      documentoUnificado: null,
      documentoUnificadoCarregado: false
    }
  },
  computed: {
    documentoUnificadoGrv () {
      return this.documentoUnificado
    }
  },
  methods: {
    async toggle () {
      this.open = !this.open
      if (this.open && !this.documentoUnificadoCarregado) {
        this.documentoUnificadoCarregado = true
        try {
          const {data} = await getDocumentoUnificadoGrv(this.grv.id)
          this.documentoUnificado = data
        } catch (error) {
          this.documentoUnificado = null
        }
      }
    },
    hide () {
      this.open = false
    },
    deleteGrv () {
      this.$emit('excluirGrv', this.grv.id)
    },
    emitirSegundaVia () {
      this.$bar.start()
      this.$loaderOverlay.open().message('Gerando documento, aguarde...')
      const {id, numero} = this.grv
      emitirSegundaVia(id).then((response) => {
        let callbackEnd = () => {
          createDownloadLink(response.data, `grv_${numero}.pdf`)
          this.$bar.finish()
          this.$loaderOverlay.hide()
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$loaderOverlay.hide()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    criarGgv () {
      const {grv} = this
      this.$router.push({name: 'grv.visualizar.ggv', params: {id: grv.id}})
    },
    openRetirada () {
      if (!this.grv.ggv) {
        alert('É necessário cadastrar uma GGV antes.')
        return
      }
      this.$router.push({name: 'grv.visualizar.patio', params: {id: this.grv.id}})
    },
    bloquearParaLeilao () {
      this.$emit('bloquearParaLeilao', this.grv.id)
    },
    async downloadDocumentoUnificado () {
      try {
        this.$loaderOverlay.open()
        const {data} = await getDocumentoUnificadoGrv(this.grv.id)

        if (data && data.url) {
          const link = document.createElement('a')
          link.href = data.url
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        this.$loaderOverlay.hide()
      } catch (error) {
        alert('Ocorreu um erro ao acessar o documento unificado, tente novamente')
        this.$loaderOverlay.hide()
        console.log(error)
      }
    }
  }
}
</script>

<template>
  <div class="btn-group dropdown" :class="{open}" v-click-out="hide">
    <a @click="emitirSegundaVia" class="btn btn-info btn-xs">Emitir GRV</a>
    <button type="button" class="btn btn-info btn-xs dropdown-toggle" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle">
      <span class="caret"></span>
      <span class="sr-only">Toggle Dropdown</span>
    </button>
    <ul class="dropdown-menu dropdown-menu-right no-padder">
      <li>
        <a @click="emitirSegundaVia"><i class="fa fa-file-pdf-o m-r-xs"></i> Emitir GRV Completa</a>
      </li>
      <li  v-if="grv.status > 99 && grv.status < 200">
        <a @click="$emit('emitirDocumentoRetirada', grv)"><i class="fa fa-file-pdf-o m-r-xs"></i> Emitir PDF Retirada</a>
      </li>
      <li>
        <a @click="$emit('openDeclaracaoAcessoVeiculo', grv)"><i class="fa fa-file-pdf-o m-r-xs"></i> Declaração de Acesso ao Veículo</a>
      </li>
      <li v-if="documentoUnificadoGrv">
        <a @click="downloadDocumentoUnificado"><i class="fa fa-file-pdf-o m-r-xs"></i> Emitir Scan Unificado</a>
      </li>
      <li class="separator"></li>
      <li>
        <a v-if="ACL.check('criar_ggv_detro', currentUser.id)" @click="criarGgv">
          <i class="fa fa-file-o m-r-xs"></i> Vistoria (GGV)
        </a>
      </li> <!-- :class="{'disabled': grv.status > 1}" -->
      <li>
        <a @click="openRetirada"><i class="fa fa-file-o m-r-xs"></i> Retirada</a>
      </li>
      <li class="separator"></li>
      <li>
        <a @click="$emit('verHistoricoDeLeiloes', grv)"><i class="fa fa-gavel"></i> Histórico de Leilões</a>
      </li>
      <li v-if="possuiACL('visualizar_historico_alteracoes_grv')">
        <a @click="$emit('verHistoricoDeAlteracoes', grv)"><i class="fa fa-history"></i> Histórico de Alterações</a>
      </li>
      <li v-if="isAdministradorExclusivo" >
        <a @click="bloquearParaLeilao">
          <span :class="{'text-danger': !grv.bloqueadoParaLeilao}">
            <i :class="`fa fa-${grv.bloqueadoParaLeilao ? 'check' : 'ban'}`"></i> {{ grv.bloqueadoParaLeilao ? 'Desbloquear ' : 'Bloquear' }} para leilões
          </span>
        </a>
      </li>
      <li>
        <a class="text-danger" @click="deleteGrv" v-if="ACL.check('excluir_grv', currentUser.id)">
          <span class="text-danger"><i class="fa fa-remove"></i> Excluir GRV</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.separator {
  border: 1px solid rgba(149, 175, 192, .5);
  margin: 7px auto;
}
</style>



// WEBPACK FOOTER //
// BtnAcaoListaGrv.vue?00a74533